module.exports = __webpack_public_path__ + "img/wycExample.2530c234.png";